

$('.upsellSlider').slick({
  slidesToShow: 2,
  lazyLoad: 'ondemand',
  slidesToScroll: 1,
  // autoplay: true,
  // autoplaySpeed: 2000,
  cssEase: 'linear',
  arrows:true
});